export function footer() {
    let openClass = "open";

    $(".footer-nav-list").on("click", ".footer-nav-button", function (e) {

        if (!$(this).hasClass(openClass) && $(window).width() < 768) {
            e.preventDefault();
        }

        let $btn = $(this);
        let $item = $btn.closest("li");
        let isOpen = $item.hasClass(openClass);

        $btn
            .toggleClass(openClass)
            .attr("aria-expanded", !isOpen);
        $item
            .toggleClass(openClass)
            .find(".footer-nav-inner").slideToggle();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/footer.js